<mat-dialog-content>
  <section class="w3l-hero-headers-11 p-sticky-md">
    <div class="top-header">
        <div class="d-grid grid-columns-top-3">
            <div class="accounts">
                <ul>
                    <li></li>
                    <li></li>
                </ul>
            </div>
            <div class="search">
                <form action="search-results.html" method="get">
                     <label> </label>
                    <input id="search" name="search" type="text" [(ngModel)]="expcode" (change)="retriveExpensesLookup()" placeholder="Serial"  >
                    <label>       </label>

                    <label>       </label>
                    <input id="search" name="search" type="text" [(ngModel)]="expname" (change)="retriveExpensesLookup()" placeholder="Name">

                </form>
            </div>
        </div>
    </div>
  </section>

  <table style="Height: 15px;">
    <thead>
        <tr >
            <th style="width: 10%;height: 5px;">Code</th>
            <th style="width: 40%;height: 5px;">Name</th>
            <th style="width: 40%;height: 5px;">Arabic Name</th>
            <th style="width: 20%;height: 5px;">Choose</th>
        </tr>
    </thead>
    <tbody>
      <tr *ngFor="let pro of expensesList; let i = index">
            <td data-column="Protocol ID">{{pro.expcode}}</td>
            <td data-column="Document Date">{{pro.expname}}</td>
            <td data-column="Protocol Name">{{pro.expnotes}}</td>
            <td data-column="Choose"><button type="button" class="theme-button btn" name="select" id="select" (click)="SelectExpenses(pro)">Select</button>
      </td>
        </tr>

    </tbody>
  </table>
  </mat-dialog-content>




